/* eslint-disable */
import { useModal } from "../../../../utils/ModalContext";
import { ethers } from "ethers";
import coin from "../../../../assets/images/coin.png";
import CountdDown from "../../../../common/countDown";
import Counter from "../../../../common/counter";
import Particle from "../../../../common/particle/v1";
import Button from "../../../../common/button";
import PopupError from "../../popupError";
import PopupLoader from "../../popupLoader";
import PopupConnect from "../../popupConnect";
import MintNowModal from "../../../../common/modal/mintNowModal";
import { serializeError } from "eth-rpc-errors";

import config from "../../../../utils/config.json";
import {
  BLOCK_REGISTRY,
  CANDY_MACHINE,
  MIN_GAS_LIMIT,
  MAX_GAS_LIMIT,
  SURPLUS
} from "../../../../utils/constants";

import Block_ABI from "../../../../abi/Block.json";
import CandyMachine_ABI from "../../../../abi/CandyMachine.json";

import {
  isWalletConnected,
  AccountsMetamask,
} from "../../../../lib/metamaskhandler";

import data from "../../../../assets/data/particle/bannerV2Particles";
import BannerStyleWrapper from "./Banner.style";
import { useState } from "react";

const Banner = () => {
  const {
    mintModalHandle,
    totalSupply,
    popupMetamaskHandle,
    setPopup,
    isPopupMetamask,
    popupErrorHandle,
    isPopupError,
    isPopup,
    popupHandle,
    userAddress,
    visibility,
  } = useModal();
  const [count, setCount] = useState(1);
  const [error, setError] = useState(" ");
  const [balanceOf, setBalanceOf] = useState(0);
  const [logs, setLogs] = useState({});
  const [inputValue, setInputValue] = useState("1");

  if (window.ethereum) {
    const provider = new ethers.providers.Web3Provider(window.ethereum, "any");
    const signer = provider.getSigner();

    const BlockContractInstance = new ethers.Contract(
      BLOCK_REGISTRY,
      Block_ABI,
      signer
    );

    const getBalance = async () => {
      const getBalance = await BlockContractInstance.balanceOf(
        await signer.getAddress()
      );
      setBalanceOf(getBalance.toNumber());
    };

    getBalance();
  }

  function handleInputChange(event) {
    const value = event.target.value;

    // Remove any non-digit characters
    const digitsOnly = value.replace(/[^0-9]/g, "");

    // Limit the value to be between 1 and 36
    const boundedValue = Math.min(Math.max(digitsOnly, 1), 36);

    // If the input is empty, clear the state
    if (value === "") {
      setInputValue("");
    } else {
      setInputValue(boundedValue);
    }
  }

  function handleIncrement() {
    const newValue = parseInt(inputValue) + 1;
    if (newValue <= 36) {
      setInputValue(newValue.toString());
    }
  }

  function handleDecrement() {
    const newValue = parseInt(inputValue) - 1;
    if (newValue >= 1) {
      setInputValue(newValue.toString());
    }
  }

  const isInputValid =
    inputValue !== "" &&
    inputValue >= 1 &&
    inputValue <= 36 &&
    inputValue <= balanceOf;

  const errorNotification = (errorMessage) => {
    const serializedError = serializeError(errorMessage);
    console.log(errorMessage);
    const error = serializedError.data.originalError.reason;
    setError(error.replace("execution reverted: ", ""));

    if (isPopup) {
      setPopup(false);
    }

    popupErrorHandle();
  };

  const handleFreeMint = async () => {
    if (!isWalletConnected()) {
      popupMetamaskHandle();
    }

    if (window.ethereum) {
      const provider = new ethers.providers.Web3Provider(
        window.ethereum,
        "any"
      );
      const signer = provider.getSigner();

      const contractCandyMachine = new ethers.Contract(
        CANDY_MACHINE,
        CandyMachine_ABI,
        signer
      );
      if (!isWalletConnected()) {
        popupMetamaskHandle();
      } else {
        try {
          // let gasLimit =
          //   await contractCandyMachine.estimateGas.reclaimMultipleLand(
          //     inputValue,
          //     1
          //   );
          // console.log("gasLimit:", gasLimit.toNumber());
          // console.log("gasLimit:", gasLimit.toNumber() + inputValue * 100000);

          const getGasLimit = async () => {
            let gasLimit =
              await contractCandyMachine.estimateGas.reclaimMultipleLand(
                inputValue,
                1
              ); 

            let newGasLimit = gasLimit.toNumber() + inputValue * SURPLUS
            console.log("newGasLimit: ", newGasLimit)

            if (newGasLimit < MIN_GAS_LIMIT) {
              return MIN_GAS_LIMIT;
            } else if (newGasLimit > MAX_GAS_LIMIT) {
              return MAX_GAS_LIMIT;
            } else {
              return newGasLimit;
            }
          };

          const reclaimMultipleLand =
            await contractCandyMachine.reclaimMultipleLand(inputValue, 1, {
              gasLimit: await getGasLimit(),
            });

          if (reclaimMultipleLand.confirmations == 0) {
            setPopup(true);
          }

          const reclaimMultipleLandTx = await reclaimMultipleLand.wait();

          if (reclaimMultipleLandTx) {
            setPopup(false);
          }

          setLogs(await reclaimMultipleLand.wait());

          if (logs.confirmations != 0) {
            mintModalHandle();
          }
        } catch (err) {
          setPopup(false);
          errorNotification(err);
        }
      }
    }
  };

  return (
    <BannerStyleWrapper className="bithu_v2_baner_sect" id="home">
      <div className="container">
        <div className="bithu_v2_baner_content">
          <h2>
            {" "}
            <span className="banner-emot">
              <img
                className="heading_shape"
                src={coin}
                alt="bithu nft heading shape"
              />
            </span>
            you own <span>{balanceOf}</span> block!
          </h2>
          <h3>{totalSupply > 0 ? totalSupply : "N/A"} Already Minted</h3>
          <ul className="mint_count_list">
            <li>
              <h5>Quantity</h5>
              <div className="mint_quantity_sect">
                <button
                  className="input_number_decrement"
                  onClick={() => handleDecrement()}
                >
                  -
                </button>
                <input
                  className="input_number"
                  type="text"
                  value={inputValue}
                  onInput={handleInputChange}
                />
                <button
                  className="input_number_increment"
                  onClick={() => handleIncrement()}
                >
                  +
                </button>
              </div>
              <h5>
                <span>{inputValue}</span> BLOCK
              </h5>
            </li>
          </ul>
          <div className="bithu_v2_baner_buttons text-center">
            <Button
              lg
              variant={isInputValid ? "mint" : "mint-disabled"}
              disabled={!isInputValid}
              onClick={() => handleFreeMint()}
            >
              Mint Now
            </Button>
          </div>

          <div className="footer_banner">
            <p>
              By clicking “<strong>MINT NOW</strong>”, you agree to our{" "}
              <a href="https://coderblock.com/toc-metaverse">
                Terms of Service
              </a>{" "}
              and our{" "}
              <a
                className="link-policy"
                href="https://coderblock.com/policies/privacy-metaverse"
              >
                Privacy Policy.{" "}
              </a>
              Select the number of plots and click on “<strong>MINT NOW</strong>
              ”: the location and the type of lands will be randomly assigned by
              the algorithm.
            </p>
          </div>

          <Particle className="v2_baner_stars" particles={data} />
        </div>
      </div>
      {visibility && <MintNowModal logs={logs} />}
      {isPopupError && (
        <div className="popUp_container">
          <PopupError popupHandle={popupErrorHandle} error={error} />
        </div>
      )}
      {isPopupMetamask && (
        <div className="popUp_container">
          <PopupConnect popupHandle={popupMetamaskHandle} />
        </div>
      )}
      {isPopup && (
        <div className="popUp_container">
          <PopupLoader popupHandle={popupHandle} />
        </div>
      )}
    </BannerStyleWrapper>
  );
};

export default Banner;
